import { CircularProgress, InputAdornment, TextField } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import { LabelInput } from '../../Main'
import CustomSelect from './SelectInputStyle'

const SelectInput = (props) => {
  const {
    clearOnBlur = true,
    labelInput,
    labelStyle = { color: '#444', fontWeight: '700', fontSize: '0.875rem' },
    options,
    optiontype = 'object',
    itemname,
    idname = 'uid',
    valueidname = 'uid',
    loading = false,
    required = false,
    sx = {},
    placeholder = '',
    adornmentText,
    ...otherProps
  } = props

  return (
    <>
      {labelInput && (
        <LabelInput sx={{ ...labelStyle }}>
          {labelInput}
          {required && <span style={{ color: 'red' }}>*</span>}
        </LabelInput>
      )}
      <CustomSelect
        {...otherProps}
        sx={{ ...sx, marginBottom: '10px' }}
        selectOnFocus
        clearOnBlur={clearOnBlur}
        handleHomeEndKeys
        options={options ? options : []}
        isOptionEqualToValue={(option, value) => {
          if (typeof value === 'string' && typeof option === 'string') return option === value
          if (typeof value === 'string' && typeof option === 'object')
            return option[idname] === value
          if (typeof value === 'object' && typeof option === 'string')
            return option === value[valueidname]
          if (typeof value === 'object' && typeof option === 'object')
            return option[idname] === value[valueidname]
          return false
        }}
        getOptionLabel={(option) => {
          // Fungsi utilitas untuk mengambil nilai dari properti bersarang
          const getNestedValue = (obj, path) => {
            return path
              .split('.')
              .reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : ''), obj)
          }

          if (optiontype === 'string') return option

          if (typeof option === 'string') {
            const temp = options?.filter((item) => getNestedValue(item, idname) === option)[0]
            return temp ? getNestedValue(temp, itemname) : ''
          }

          return getNestedValue(option, itemname) || option[itemname] || ''
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder || ''}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                  {adornmentText && (
                    <InputAdornment
                      position="end"
                      sx={{
                        padding: '14px 14px',
                        backgroundColor: '#DDDDDD',
                        borderRadius: '25px',
                      }}
                    >
                      <span
                        style={{
                          fontWeight: '700',
                          color: '#7B8186',
                        }}
                      >
                        {adornmentText}
                      </span>
                    </InputAdornment>
                  )}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </>
  )
}

SelectInput.propTypes = {
  clearOnBlur: PropTypes.bool,
  itemname: PropTypes.string,
  labelInput: PropTypes.any,
  labelStyle: PropTypes.any,
  loading: PropTypes.bool,
  onChange: PropTypes.func,
  optiontype: PropTypes.string,
  options: PropTypes.array,
  props: PropTypes.any,
  required: PropTypes.bool,
  sx: PropTypes.any,
  idname: PropTypes.any,
  valueidname: PropTypes.any,
  placeholder: PropTypes.any,
  adornmentText: PropTypes.string,
}

export default SelectInput
